/**
  * 判断是否对象
  *
  * @param {Object} obj 对象
  * @return {Boolean}
  */
function isPlainObject (obj) {
  return obj ? obj.constructor === Object : false
}

module.exports = isPlainObject



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isPlainObject.js
// module id = 40
// module chunks = 98